import * as ACTION from 'actions';
import _ from 'lodash';

const initialState = {
    id: null,
    projectId: null,
    surveyCode: null,
    survey: {
        image: '',
        title: '',
        description: '',
        input: [
        ]
    },
    startAt: null,
    endAt: null
};

export function survey(state = initialState, action) {
    if (action == null) return state;
    switch (action.type) {
        case ACTION.FETCH_SURVEY:
            action.survey.survey = JSON.parse(action.survey.survey);
            return action.survey;
        case ACTION.UPDATE_SURVEY:
            action.survey.survey = JSON.parse(action.survey.survey);
            return action.survey;
        default:
            return state
    }
}

export function surveys(state=[], action) {
    if(action == null) return  state;
    let _list = Object.assign([], state);
    let index = -1;
    switch (action.type) {
        case ACTION.FETCH_SURVEY_LIST:
            return _.sortBy(action.surveyList, 'createdAt');
        case ACTION.UPDATE_SURVEY:
            index = state.findIndex(data => data.id === action.survey.id);
            _list[index] = action.survey;
            return _list;
        case ACTION.ADD_SURVEY:
            // action.survey.survey = JSON.parse(action.survey.survey);
            return [...state,action.survey];
        case ACTION.DELETE_SURVEY:
            index = state.findIndex(data => data.id === action.survey.id);
            _list.splice(index, 1);
            return _list;
        default:
            return state
    }
}
